import { render } from "./Stats.vue?vue&type=template&id=384788ca"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"

import "./Stats.vue?vue&type=style&index=0&id=384788ca&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_webpack@5.111.1_clean-css@5.3.3_c_b42aad1f9cb297798e408b604a7fd1c5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__